import axiosInstance from "./axiosInstance";
import { API_KEY, API_URL, USER_ID } from "./settings";

export default function setMaterialComplete({ materialId, classNum }) {
     const URL = `${API_URL}/MaterialEstudios/SetMaterialCompletado/${materialId}/${classNum}/${USER_ID}/${API_KEY}/${USER_ID}`;
     const axios = axiosInstance();
     axios.get(URL);
}
